import domready from 'domready';
import Velocity from 'velocity-animate';
import Utilities from '@js/src/Utilities';

class PageErrors {
    constructor() {
        domready(() => {
            this.elem = document.getElementById('alerts');
        });
    }

    hide(uuid) {
        let alert = document.getElementById(`alert-${uuid}`);
        Velocity(alert, 'slideUp', {
            duration: 500,
            complete: () => {
                this.elem.removeChild(alert);
            },
        });
    }

    show(uuid, hideAfter = 8) {
        let alert = document.getElementById(`alert-${uuid}`);

        // Show the progress indicator
        Velocity(alert, 'slideDown', { duration: 300 });

        // Set new one
        if (hideAfter > 0) {
            setTimeout(() => {
                this.hide(uuid);
            }, hideAfter * 1000);
        }
    }

    success(text, hideAfter = 8) {
        let uuid = Utilities.uuid();
        this.elem.innerHTML += `
            <div id="alert-${uuid}" class="c-alert c-alert--success">
                <div class="flex">
                    <svg class="flex-shrink-0 h-4 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" class="st1"></path></svg>
                    <div>
                        <p>${text}</p>
                    </div>
                </div>
            </div>
        `;

        this.show(uuid, hideAfter);
    }

    warning(text, hideAfter = 8) {
        let uuid = Utilities.uuid();
        this.elem.innerHTML += `
            <div id="alert-${uuid}" class="c-alert c-alert--warning">
                <div class="flex">
                    <svg class="flex-shrink-0 h-4 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path></svg>
                    <div>
                        <p>${text}</p>
                    </div>
                </div>
            </div>
        `;

        this.show(uuid, hideAfter);
    }

    error(text, hideAfter = 8) {
        let uuid = Utilities.uuid();
        this.elem.innerHTML += `
            <div id="alert-${uuid}" class="c-alert c-alert--error">
                <div class="flex">
                    <svg class="flex-shrink-0 h-4 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path></svg>
                    <div>
                        <p>${text}</p>
                    </div>
                </div>
            </div>
        `;

        this.show(uuid, hideAfter);
    }

    initialize() {
        domready(() => {
            // Iterate through each existing alert, assign an ID and make it officially show up
            this.elem.querySelectorAll('.c-alert').forEach(alert => {
                if (alert.getAttribute('id') === null) {
                    let uuid = Utilities.uuid();
                    alert.setAttribute('id', `alert-${uuid}`);

                    this.show(uuid);
                }
            });
        });
    }
}

// Export the module
export default new PageErrors();
